const { width, height } = window.screen;
const isMobile = width >= 320 && width <= 768
const isLarge = width > 768 && width <= 1920
const isExtraLarge = width > 1920

const normalFontSizeRate = 14 / 1920

const rem = (remsize) => {
    return remsize * normalFontSizeRate * width * (Math.max(window.devicePixelRatio || 1))
}

const screenInfo = {
    width: window.screen.width,
    height: window.screen.height,
    availWidth: window.screen.availWidth,
    availHeight: window.screen.availHeight,
    colorDepth: window.screen.colorDepth,
    pixelDepth: window.screen.pixelDepth,
    windowDevicePixcelRatio: window.devicePixelRatio,
    windowInnerWidth: window.innerWidth,
    windowInnerHeight: window.innerHeight,
    oneRem: rem(1)
}
console.info('=== ScreenInfo ===', JSON.stringify(screenInfo, null, 4))

const TOPHEADER_HEIGHT = 3
const APPHEADER_HEIGHT = 5

const HEADER_HEIGHT = (isMobile ? APPHEADER_HEIGHT : APPHEADER_HEIGHT + TOPHEADER_HEIGHT) + 'rem'

export {
    width,
    height,
    isMobile, isLarge, isExtraLarge,
    HEADER_HEIGHT,
    rem
}

// export default function useWindowDimensions() {
//     const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

//     useEffect(() => {
//         function handleResize() {
//             setWindowDimensions(getWindowDimensions());
//         }

//         window.addEventListener('resize', handleResize);
//         return () => window.removeEventListener('resize', handleResize);
//     }, []);

//     const width = windowDimensions.width
//     let deviceType = '4K'
//     switch (width) {
//         case 320:
//             deviceType = 'MobileS'
//             break;
//         case 375:
//             deviceType = 'MobileM'
//             break;
//         case 425:
//             deviceType = 'MobileL'
//             break;
//         case 768:
//             deviceType = 'Tablet'
//             break;
//         case 1024:
//             deviceType = 'Laptop'
//             break;
//         case 1440:
//             deviceType = 'LaptopL'
//             break;

//         default:
//             deviceType = '4K'
//             break;
//     }

//     return {
//         ...windowDimensions,
//         deviceType
//     };
// }